import { Button } from '@bfe/moly';
import { AssethistoryIcon } from '@bfe/moly-icons';
import { useNavigate } from 'react-router-dom';

import AccountBasicItem from '@/components/AccountBasicItem';
import { useUserProfile } from '@/hooks/useUserProfile';
import { useI18nContext } from '@/i18n/I18n';

const Index = () => {
  const [$t] = useI18nContext();
  const navigate = useNavigate();
  const { profile } = useUserProfile();

  const toAccountActivity = () => {
    navigate('/app/user/account-activity');
  };

  const AutoBanContent = () => {
    return (
      <>
        {!profile?.result?.is_submember && (
          <div className="account-activity-content">
            <span>{$t('accountAbnormal')} </span>
            <span
              className="link_a"
              onClick={() => navigate('/app/user/auto-ban-account')}
            >
              {$t('autoBanAccount')}
            </span>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <AccountBasicItem
        icon={'account active'}
        molyIcon={<AssethistoryIcon />}
        text={$t('Account Activities')}
        subText={<AutoBanContent />}
        operation={
          <>
            <Button
              onClick={() => toAccountActivity()}
              size="small"
              data-radius="small"
              variant="secondary"
            >
              {$t('View New')}
            </Button>
          </>
        }
      />
    </>
  );
};
export default Index;
